(function() {
  // Multiple sections include this asset. Register one shared controller per page.
  if (window.bikezonePopularCategoriesInitialized) return;
  window.bikezonePopularCategoriesInitialized = true;

  const instances = new Map();

  function getSectionElement(root) {
    if (!root) return null;
    if (root.matches && root.matches('[data-popular-categories-scroll]')) return root;
    return root.querySelector('[data-popular-categories-scroll]');
  }

  function getSectionSettings(section) {
    const perRow = Number(section.dataset.perRow) || 4;
    const mobileSlidesPerView = Number(section.dataset.mobileSlidesPerView) || 0;
    const hasGutter = section.dataset.enableGutter !== 'false';
    const centerInsufficientSlides = section.dataset.centerInsufficientSlides !== 'false';
    const fillInsufficientSlides = section.dataset.fillInsufficientSlides === 'true';

    return {
      perRow,
      centerInsufficientSlides,
      fillInsufficientSlides,
      spaceBetweenSmall: hasGutter ? 12 : 0,
      spaceBetweenLarge: hasGutter ? 16 : 0,
      breakpoints: {
        0: {
          slidesPerView: mobileSlidesPerView || 1.15,
          spaceBetween: hasGutter ? 12 : 0
        },
        480: {
          slidesPerView: mobileSlidesPerView || 1.35,
          spaceBetween: hasGutter ? 12 : 0
        },
        640: {
          slidesPerView: mobileSlidesPerView || Math.min(2.1, perRow),
          spaceBetween: hasGutter ? 12 : 0
        },
        769: {
          slidesPerView: Math.min(2.6, perRow),
          spaceBetween: hasGutter ? 16 : 0
        },
        990: {
          slidesPerView: Math.min(3.2, perRow),
          spaceBetween: hasGutter ? 16 : 0
        },
        1200: {
          slidesPerView: perRow + 0.15,
          spaceBetween: hasGutter ? 16 : 0
        }
      }
    };
  }

  function fitInsufficientSlides(settings, slideCount) {
    if (!settings.fillInsufficientSlides || slideCount <= 0) return settings;

    const breakpoints = Object.entries(settings.breakpoints).reduce((acc, [width, breakpoint]) => {
      acc[width] = {
        ...breakpoint,
        slidesPerView: Math.min(breakpoint.slidesPerView, slideCount)
      };

      return acc;
    }, {});

    return {
      ...settings,
      breakpoints
    };
  }

  function initSection(section) {
    if (!section || typeof window.Swiper === 'undefined') return;

    const viewport = section.querySelector('[data-scroll-viewport]');
    if (!viewport) return;

    const slideCount = viewport.querySelectorAll('.swiper-slide').length;
    const prevButton = section.querySelector('[data-scroll-prev]');
    const nextButton = section.querySelector('[data-scroll-next]');
    const baseSettings = getSectionSettings(section);
    const settings = fitInsufficientSlides(baseSettings, slideCount);

    // Section-load events can repeat for the same DOM node.
    if (instances.has(section)) return;

    if (slideCount <= 1) {
      if (prevButton) prevButton.disabled = true;
      if (nextButton) nextButton.disabled = true;
      return;
    }

    const updateNavigationState = (swiper) => {
      if (!prevButton || !nextButton) return;

      prevButton.disabled = swiper.isBeginning || swiper.isLocked;
      nextButton.disabled = swiper.isEnd || swiper.isLocked;
    };

    const swiper = new window.Swiper(viewport, {
      a11y: {
        enabled: true
      },
      observer: true,
      observeParents: true,
      watchOverflow: true,
      centerInsufficientSlides: settings.centerInsufficientSlides,
      grabCursor: true,
      simulateTouch: true,
      allowTouchMove: true,
      resistanceRatio: 0.35,
      speed: 400,
      slidesPerView: settings.breakpoints[0].slidesPerView,
      spaceBetween: settings.breakpoints[0].spaceBetween,
      breakpoints: settings.breakpoints,
      navigation: prevButton && nextButton ? {
        prevEl: prevButton,
        nextEl: nextButton,
        disabledClass: 'is-disabled'
      } : undefined,
      on: {
        afterInit: updateNavigationState,
        slideChange: updateNavigationState,
        resize: updateNavigationState,
        lock: updateNavigationState,
        unlock: updateNavigationState,
        fromEdge: updateNavigationState,
        toEdge: updateNavigationState
      }
    });

    instances.set(section, swiper);
  }

  function initAll(root = document) {
    if (root.matches && root.matches('[data-popular-categories-scroll]')) {
      initSection(root);
      return;
    }

    root.querySelectorAll('[data-popular-categories-scroll]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll();
    }, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    const section = getSectionElement(event.target);
    if (!section || !instances.has(section)) return;

    instances.get(section).destroy(true, true);
    instances.delete(section);
  });
})();
